// Signing in to tensor: the family's accounts, but a session of its own
// (design 00 4.2): password, or a passkey (one passkey works in both apps).
import { type FormEvent, useState } from 'react'

import { errorText } from '../../api/client'
import { passkeyErrorText, passkeysSupported } from '../../features/passkeys/passkeys'
import { guessDeviceName } from '../../lib/device'
import { ErrorText, Field } from '../../ui/common'
import { engine } from '../engine'
import { useT } from '../store'

export function LoginScreen() {
  const reason = useT((s) => s.signedOutReason)
  const [login, setLogin] = useState('')
  const [password, setPassword] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const device = `${guessDeviceName()} · tensor`.slice(0, 60)

  async function submit(e: FormEvent) {
    e.preventDefault()
    if (busy) return
    setBusy(true)
    setError(null)
    try {
      await engine.login(login.trim(), password.normalize('NFC'), device)
    } catch (err) {
      setError(errorText(err))
      setBusy(false)
    }
  }

  async function withPasskey() {
    if (busy) return
    setBusy(true)
    setError(null)
    try {
      await engine.loginWithPasskey(device)
    } catch (err) {
      setError(passkeyErrorText(err))
      setBusy(false)
    }
  }

  return (
    <div className="auth">
      <div className="brand">
        <img src="/icons/favicon.svg" alt="" width={72} height={72} />
        <h1>tensor</h1>
        <p>우리 집 수입·지출 기록</p>
      </div>
      <form className="card" onSubmit={submit}>
        {reason && <p className="notice">{reason}</p>}
        <Field label="아이디">
          <input
            value={login}
            onChange={(e) => setLogin(e.target.value)}
            autoComplete="username"
            autoCapitalize="none"
            spellCheck={false}
            required
            name="login"
          />
        </Field>
        <Field label="비밀번호">
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
            name="password"
          />
        </Field>
        <ErrorText text={error} />
        <button className="primary" type="submit" disabled={busy}>
          {busy ? '로그인 중…' : '로그인'}
        </button>
        {passkeysSupported() && (
          <button type="button" className="secondary" disabled={busy} onClick={() => void withPasskey()}>
            지문·PIN으로 로그인
          </button>
        )}
        <p className="muted small">메신저와 같은 아이디로 로그인합니다. 계정이 없으면 관리자에게 초대 링크를 받으세요.</p>
      </form>
    </div>
  )
}
